// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect, useRef, useState } from 'react';

import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Hotspot from '@cloudscape-design/components/hotspot';
import Input, { InputProps } from '@cloudscape-design/components/input';
import Link from '@cloudscape-design/components/link';
import Checkbox from "@cloudscape-design/components/checkbox";
import ExpandableSection from "@cloudscape-design/components/expandable-section";


import Select, { SelectProps } from '@cloudscape-design/components/select';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
//import { useStore } from '../../store';
import Flashbar, { FlashbarProps } from '@cloudscape-design/components/flashbar';
import Grid from '@cloudscape-design/components/grid';
import { useGlobalState } from '../../../context/GlobalStateContext'
import { Badge, Box, DatePicker } from '@cloudscape-design/components';
import { format } from 'date-fns';

import { isValidPhone, storeJWT } from '../../../commons/functions'; // Import the function
import Icon from '@mdi/react';
import { mdiAlertBox, mdiCheckCircle, mdiLock } from '@mdi/js';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import DatePickerModal from '../../../../components/DatePickerModal';

export const UsersAddAdminPage = () => {
    const storeAdmin = useStoreAdmin();
    const { idPropiedad } = useGlobalState();
    const { propiedad, setPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();
    const [idControl, setIdControl ] = useState(0);
    const [showForm2, setShowForm2] = useState(-1);

    const [jobName, setJobName] = useState('');
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

    const [isDisabledNombre, setIsDisabledNombre] = useState(false);
    const [isDisabledApellido, setIsDisabledApellido] = useState(false);
    const [isDisabledEmail, setIsDisabledEmail] = useState(false);
    const [isDisabledMovil, setIsDisabledMovil] = useState(false);
    const [isDisabledBtnNext, setIsDisabledBtnNext] = useState(true);
    const [btnUserInfoVisible, setBtnUserInfoVisible] = useState(false);


    const { setLoading } = useGlobalState();
    const inputRefMovil = useRef<HTMLInputElement>(null);
    /*
      const onJobNameChangePhone = (event: any) => {
        setJobName(event.detail.value);
        setMessages([]);
      };
      */
    const handleNumericInputChange: InputProps["onChange"] = (event) => {
        const digitsOnly = event.detail.value.replace(/\D/g, '');
        setInputMovil(digitsOnly);
        setJobName(event.detail.value);
        setMessages([]);
        setIsDisabledBtnNext(!isValidPhone(digitsOnly)); // Initially disable the button

    };



    const handleValidatePhone = async () => {
        const regex = /^\+?56\d{9}$/;
        if (!regex.test(inputMovil)) {
            setMessages([
                {
                    type: 'error',
                    content: 'Número inválido. Use formato +56912345678 o 56912345678',
                    id: 'error-msg',
                },
            ]);
            return
        }
        const digitsOnly = inputMovil.replace(/\D/g, '');

        setIsDisabledMovil(true);

        setPendingJobCreation(true);
        try {
            setLoading(true)
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/users/preregister',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    movil: digitsOnly,
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
                setIsDisabledMovil(false);
            }
            const data = await response.json();

            storeAdmin(data);
            if (data.code === 0) {



                if (data.user) {
                    // Set the input values if the data exists
                    setInputNombre(data.user.nombre || '');  // If the field is not empty, set the value
                    setInputApellido(data.user.apellido || '');
                    setInputEmail(data.user.email || '');

                    // If any field is populated, disable the inputs

                    setIsDisabledNombre(data.user.nombre ? true : false)
                    setIsDisabledApellido(data.user.apellido ? true : false)
                    setIsDisabledEmail(data.user.email ? true : false)
                    setIdControl(data.user.idControl)
                    if(data.user.adminFunciones && data.user.adminFunciones.idAdminFunciones) setIdAdminFunciones(data.user.adminFunciones.idAdminFunciones)
                    if (data.user.nombre !== '' && data.user.apellido !== '' && data.user.email !== '') {
                        setInfoUserComplete(true)
                        setBtnUserInfoVisible(false)
                    } else {
                        setInfoUserComplete(false)
                        setBtnUserInfoVisible(true)

                    }
                    setShowForm2(0);
                    if (data.user.adminFunciones) {
                        if (data.user.adminFunciones.code === 0) {
                            setMessages([
                                {
                                    type: "warning",
                                    content: `Usuario ya se encuentra registrado como administrador`,
                                    id: 'server-error',
                                },
                            ])
                            setInfoUserComplete(false)
                        }
                    }
                }

            } else {
                setShowForm2(-1);
                setIsDisabledMovil(false);
            }
        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
            setIsDisabledMovil(false);
        } finally {
            setPendingJobCreation(false);
            setLoading(false)

        }
    };
    /*
      const {
        actions: { makeHelpPanelHandler },
      } = useStore();
       */
    const { navigate } = useRouter();
    const [pendingJobCreation, setPendingJobCreation] = useState(false);
    const createJob = () => {
        //setPendingJobCreation(true);
        //setTimeout(() => navigate('transcription-job-list'), 1000);
    };

    const handleCancelBtn = () => {
        setIsDisabledMovil(false);
        setShowForm2(-1);
        setInputMovil('');
        setIsDisabledBtnNext(true)
    };

    const [inputNombre, setInputNombre] = useState('');
    const [inputApellido, setInputApellido] = useState('');
    const [inputEmail, setInputEmail] = useState('');
    //const [inputMovil, setInputMovil] = useState('56975945401');
    const [inputMovil, setInputMovil] = useState('');
    //const [inputMovil, setInputMovil] = useState('56991296532');
    const [idAdminFunciones, setIdAdminFunciones] = React.useState(-1);
    const [infoUserComplete, setInfoUserComplete] = React.useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (inputRefMovil.current) {
                inputRefMovil.current.focus();
            }
        }, 500); // 2000 milliseconds = 2 seconds

        // Cleanup if component unmounts
        return () => clearTimeout(timer);
    }, []);


    const handleBtnRegisterUser = async () => {

        const body = {
            movil: inputMovil,
            nombre: inputNombre.toUpperCase(),
            apellido: inputApellido.toUpperCase(),
            email: inputEmail.toLowerCase(),
            idControl: idControl
        }

        console.log(body)
        try {
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/users/add',
                    'JWT': JWT,

                },
                body: JSON.stringify(body),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
                setIsDisabledMovil(false);
            }
            const data = await response.json();

            storeAdmin(data);
            if (data.code === 0) {
                window.location.href = "#admin/users"
            }


        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
        } finally {
            setPendingJobCreation(false);

        }
    };
    return (
        <CustomAppLayout
            //title={propiedad}

            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Administradores', href: '#admin' },
                        { text: 'Usuarios', href: '#admin/users' },
                        { text: 'Agregar usuario', href: '' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Form
                        header={
                            <Header
                                variant="h2"
                            >
                                Agregar nuevo usuario administrador
                            </Header>
                        }

                        actions={

                            <SpaceBetween direction="horizontal" size="xs">

                                {showForm2 >= 0 && (
                                    <Button variant="link" disabled={pendingJobCreation} onClick={handleCancelBtn}>
                                        Cancelar
                                    </Button>
                                )}

                                {showForm2 >= 0 && (
                                    <Button variant="primary" loading={pendingJobCreation} disabled={idAdminFunciones>0} onClick={handleBtnRegisterUser} ariaLabel="Create job">
                                        Asignar administrador
                                    </Button>
                                )}
                            </SpaceBetween>
                        }
                    >
                        <SpaceBetween size="xl">
                            <Container header={<Header variant="h3">Identificación del usuario</Header>}>
                                <SpaceBetween size="l">
                                    <Flashbar items={messages} />
                                    <FormField
                                        label="Número de móvil"
                                        constraintText="El número de móvil debe ser en formato internacional (Ej: +56912345678)."
                                        info={
                                            <Link
                                                variant="info"

                                                ref={inputRefMovil}
                                                //onFollow={makeHelpPanelHandler('name')}
                                                ariaLabel="Sintaxis del móvil."
                                            >
                                                Info
                                            </Link>
                                        }
                                    >
                                        <Hotspot hotspotId="transcription-job-name">
                                            <SpaceBetween direction="horizontal" size="xs">
                                                <Input
                                                    controlId='infoMovil'
                                                    value={inputMovil}
                                                    placeholder="56912354678"
                                                    disabled={isDisabledMovil}
                                                    onChange={handleNumericInputChange}

                                                    autoFocus
                                                    autoComplete="new-password"

                                                    onKeyDown={(e) => {
                                                        if (e.detail.key === 'Enter' && isValidPhone(inputMovil.replace(/\D/g, ''))) {
                                                            handleValidatePhone()
                                                        }
                                                    }}
                                                />
                                                {showForm2 === -1 && (
                                                    <Button onClick={handleValidatePhone} disabled={isDisabledBtnNext} variant="primary" loading={pendingJobCreation} >Siguiente</Button>
                                                )}
                                                {showForm2 >= 0 && (
                                                    <Button onClick={handleCancelBtn} variant='normal'>Cancelar</Button>
                                                )}
                                            </SpaceBetween>
                                        </Hotspot>
                                    </FormField>
                                    {showForm2 >= 0 && (
                                        <FormField label="Información del Usuario" description="En caso de que un campo se encuentre vacío, deberá ser completado">
                                            {/* Row 1 */}
                                            <SpaceBetween direction='horizontal' size='xs'>

                                                <FormField label="Nombre">
                                                    <Input
                                                        controlId='infoNombre'
                                                        value={inputNombre}
                                                        onChange={(e) => setInputNombre(e.detail.value.toUpperCase())}
                                                        placeholder="Nombre"
                                                        readOnly={isDisabledNombre}
                                                    />
                                                </FormField>

                                                <FormField label="Apellido">
                                                    <Input
                                                        controlId='infoApellido'
                                                        value={inputApellido}
                                                        onChange={(e) => setInputApellido(e.detail.value.toUpperCase())}
                                                        placeholder="Apellido"
                                                        readOnly={isDisabledApellido}
                                                    />
                                                </FormField>
                                            </SpaceBetween>

                                            <SpaceBetween direction='horizontal' size='xs'>

                                                <FormField label="Email">
                                                    <Input
                                                        controlId='infoEmail'
                                                        value={inputEmail}
                                                        onChange={(e) => setInputEmail(e.detail.value.toLowerCase())}
                                                        placeholder="Email"
                                                        readOnly={isDisabledEmail}
                                                        type="email"
                                                    />
                                                </FormField>
                                            </SpaceBetween>



                                        </FormField>
                                    )}
                                </SpaceBetween>
                            </Container>
                        </SpaceBetween>
                    </Form>


                </>
            }
        />
    );
};
